var map = {
	"./__deprecated/done-white.svg": 25673,
	"./__deprecated/program-white.svg": 50135,
	"./__deprecated/reports-white.svg": 2346,
	"./__deprecated/vr-white.svg": 50993,
	"./about.svg": 31782,
	"./acrophobia.svg": 45475,
	"./add-vr-plan.svg": 29107,
	"./add.svg": 71480,
	"./aerophobia.svg": 11429,
	"./amaxophobia-lh.svg": 9353,
	"./amaxophobia.svg": 89664,
	"./analysis.svg": 23773,
	"./apple-badge.svg": 85547,
	"./arachnophobia.svg": 88710,
	"./arrow.svg": 57190,
	"./audio off.svg": 7052,
	"./audio-bars.svg": 58566,
	"./audio.svg": 43263,
	"./avatars/boy-1.svg": 93154,
	"./avatars/boy-2.svg": 13521,
	"./avatars/boy-3.svg": 77568,
	"./avatars/boy-4.svg": 43455,
	"./avatars/boy-5.svg": 15022,
	"./avatars/boy-6.svg": 63373,
	"./avatars/girl-1.svg": 49210,
	"./avatars/girl-2.svg": 74793,
	"./avatars/girl-3.svg": 15640,
	"./avatars/girl-4.svg": 10711,
	"./avatars/girl-5.svg": 47910,
	"./avatars/girl-6.svg": 84133,
	"./avatars/teen-boy-1.svg": 58825,
	"./avatars/teen-boy-2.svg": 97658,
	"./avatars/teen-boy-3.svg": 91531,
	"./avatars/teen-boy-4.svg": 23940,
	"./avatars/teen-boy-5.svg": 4837,
	"./avatars/teen-boy-6.svg": 73062,
	"./back.svg": 79082,
	"./billing.svg": 67744,
	"./calendar.svg": 85033,
	"./calibrate-vr.svg": 45287,
	"./calming-scene.svg": 54581,
	"./camera.svg": 58854,
	"./chat-play.svg": 69928,
	"./chat.svg": 98701,
	"./children-anxiety.svg": 78077,
	"./claustrophobia.svg": 89397,
	"./client.svg": 5766,
	"./clinician.svg": 46397,
	"./close-circle.svg": 49866,
	"./close.svg": 35837,
	"./countdown-timer.svg": 24432,
	"./credit-card.svg": 48531,
	"./cynophobia.svg": 84539,
	"./dashboard.svg": 17461,
	"./deep-water.svg": 99471,
	"./delivery-truck.svg": 64261,
	"./depression.svg": 17343,
	"./done.svg": 56903,
	"./down-arrow-alt.svg": 24129,
	"./down-arrow.svg": 5743,
	"./download.svg": 91303,
	"./ease-up-logo.svg": 3123,
	"./eating-disorder.svg": 75798,
	"./edit.svg": 975,
	"./email.svg": 11089,
	"./emojis/brain-anxious.svg": 36219,
	"./emojis/brain-avoided-red.svg": 18314,
	"./emojis/brain-confronted-blue.svg": 87427,
	"./emojis/brain-confronted.svg": 96058,
	"./emojis/brain-overcame-green.svg": 70002,
	"./emojis/brain-overcame.svg": 4232,
	"./emojis/brain-worried.svg": 83532,
	"./emojis/concerned-face.svg": 85014,
	"./emojis/crying-face.svg": 41745,
	"./emojis/depressed-face.svg": 29592,
	"./emojis/grin-face.svg": 58755,
	"./emojis/happy-face.svg": 36185,
	"./emojis/neutral-face.svg": 75748,
	"./emojis/oval-confronted.svg": 53760,
	"./emojis/oval-overcame.svg": 91914,
	"./emojis/sad-face.svg": 1283,
	"./emojis/smiley-face.svg": 5646,
	"./emojis/tear-face.svg": 52753,
	"./emojis/upset-face.svg": 848,
	"./emojis/worried-face.svg": 97247,
	"./entomophobia.svg": 23548,
	"./error.svg": 45119,
	"./error/error-image.svg": 45412,
	"./error/error-warning.svg": 54643,
	"./exercise.svg": 90845,
	"./favorite.svg": 7928,
	"./feedback.svg": 9322,
	"./figures/calm-figure.svg": 1881,
	"./figures/confidence.svg": 87473,
	"./figures/flexibility-figure.svg": 23335,
	"./figures/impactful-delivery.svg": 67173,
	"./figures/knowledge-figure.svg": 58984,
	"./figures/meditation-figure.svg": 52370,
	"./figures/mindset-figure.svg": 68264,
	"./figures/pitch-structure.svg": 46481,
	"./figures/presentation.svg": 17645,
	"./figures/superman-alt.svg": 7808,
	"./figures/superman.svg": 95554,
	"./figures/vr-figure.svg": 8162,
	"./filter.svg": 87985,
	"./forward.svg": 51626,
	"./google-play-badge.svg": 49091,
	"./guarantee.svg": 72151,
	"./header-arch-short.svg": 61288,
	"./header-arch-tall.svg": 43063,
	"./headphones.svg": 2582,
	"./help.svg": 95330,
	"./hide.svg": 32243,
	"./high-anxiety.svg": 93648,
	"./illustrations/anxiety-profile.svg": 18729,
	"./illustrations/anxious.svg": 65458,
	"./illustrations/brain-circle.svg": 94482,
	"./illustrations/brain-orange.svg": 87464,
	"./illustrations/brain-red.svg": 99679,
	"./illustrations/confident.svg": 75689,
	"./illustrations/email-open.svg": 81750,
	"./illustrations/feedback-alt.svg": 89584,
	"./illustrations/feedback-hashtag.svg": 2537,
	"./illustrations/feelings.svg": 90356,
	"./illustrations/hiding.svg": 4478,
	"./illustrations/holding phone.svg": 17224,
	"./illustrations/holding-phone-half-circle.svg": 86188,
	"./illustrations/joyful.svg": 85604,
	"./illustrations/lesson.svg": 80911,
	"./illustrations/monitoring.svg": 65457,
	"./illustrations/ok.svg": 44841,
	"./illustrations/peeking.svg": 9594,
	"./illustrations/personalised.svg": 53128,
	"./illustrations/program-learn.svg": 17864,
	"./illustrations/program-vr-plan.svg": 410,
	"./illustrations/questionnaire-alt.svg": 47432,
	"./illustrations/questionnaire.svg": 97162,
	"./illustrations/reminder.svg": 969,
	"./illustrations/start.svg": 16889,
	"./illustrations/therapist-session.svg": 81372,
	"./illustrations/track-progress.svg": 85496,
	"./illustrations/vector.svg": 59970,
	"./illustrations/vret.svg": 93204,
	"./illustrations/welcome.svg": 58813,
	"./illustrations/winking-face.svg": 28888,
	"./illustrations/your-profile.svg": 92662,
	"./increase.svg": 51899,
	"./individual.svg": 35262,
	"./invite.svg": 90764,
	"./leave-session.svg": 66111,
	"./left-arrow.svg": 92104,
	"./levels.svg": 14986,
	"./lightbulb.svg": 22272,
	"./live vr.svg": 32263,
	"./location.svg": 84310,
	"./log out.svg": 86099,
	"./logo.svg": 26962,
	"./low-anxiety.svg": 88188,
	"./maximize.svg": 10977,
	"./medium-anxiety.svg": 78745,
	"./menu.svg": 72434,
	"./microphone.svg": 26007,
	"./minimize.svg": 9427,
	"./minus.svg": 48441,
	"./modules/calming-module.svg": 11081,
	"./modules/exposure-module.svg": 1967,
	"./modules/flexibility-module.svg": 73047,
	"./modules/knowledge-module.svg": 34564,
	"./modules/meditation-module.svg": 65094,
	"./modules/mindset-module.svg": 40556,
	"./more.svg": 916,
	"./musophobia.svg": 20166,
	"./mute.svg": 72880,
	"./news.svg": 8566,
	"./nice-pic-of-adam.svg": 97365,
	"./not-active.svg": 29377,
	"./notification.svg": 30566,
	"./on-laptop.svg": 29773,
	"./orgs/1-news.svg": 354,
	"./orgs/news-hub.svg": 86510,
	"./orgs/uoo.svg": 48516,
	"./ornithophobia.svg": 5727,
	"./panic-disorder.svg": 33273,
	"./parent.svg": 53755,
	"./pause.svg": 51947,
	"./pending.svg": 87352,
	"./performance.svg": 65699,
	"./phobia.svg": 15570,
	"./phone.svg": 16345,
	"./play chat.svg": 76121,
	"./play live.svg": 28397,
	"./play outline.svg": 9159,
	"./play.svg": 10757,
	"./plus.svg": 24491,
	"./premium-alt.svg": 46740,
	"./premium.svg": 13918,
	"./privacy.svg": 72129,
	"./program.svg": 40309,
	"./programs/acrophobia-orange.svg": 35754,
	"./programs/acrophobia-purple.svg": 59506,
	"./programs/acrophobia-red.svg": 87681,
	"./programs/acrophobia-soft.svg": 77716,
	"./programs/acrophobia-white.svg": 3163,
	"./programs/aerophobia-orange.svg": 17488,
	"./programs/aerophobia-purple.svg": 63236,
	"./programs/aerophobia-red.svg": 79287,
	"./programs/aerophobia-soft.svg": 93918,
	"./programs/aerophobia-white.svg": 7377,
	"./programs/amaxophobia-soft.svg": 52193,
	"./programs/arachnophobia-orange.svg": 61857,
	"./programs/arachnophobia-purple.svg": 53205,
	"./programs/arachnophobia-red.svg": 14724,
	"./programs/arachnophobia-soft.svg": 88951,
	"./programs/arachnophobia-white.svg": 71434,
	"./programs/childrens-anxiety-orange.svg": 13369,
	"./programs/childrens-anxiety-purple.svg": 40829,
	"./programs/childrens-anxiety-red.svg": 94220,
	"./programs/childrens-anxiety-soft.svg": 35359,
	"./programs/childrens-anxiety-white.svg": 87154,
	"./programs/claustrophobia-orange.svg": 98192,
	"./programs/claustrophobia-purple.svg": 21988,
	"./programs/claustrophobia-red.svg": 67607,
	"./programs/claustrophobia-soft.svg": 78814,
	"./programs/claustrophobia-white.svg": 92913,
	"./programs/cynophobia-orange.svg": 3842,
	"./programs/cynophobia-purple.svg": 38202,
	"./programs/cynophobia-red.svg": 92585,
	"./programs/cynophobia-soft.svg": 26076,
	"./programs/cynophobia-white.svg": 85795,
	"./programs/deep-water-soft.svg": 22872,
	"./programs/default-orange.svg": 11641,
	"./programs/default-purple.svg": 37981,
	"./programs/default-red.svg": 73932,
	"./programs/default-soft.svg": 98399,
	"./programs/default-white.svg": 43026,
	"./programs/driving-orange.svg": 6787,
	"./programs/driving-purple.svg": 92891,
	"./programs/driving-red.svg": 59390,
	"./programs/driving-white.svg": 76428,
	"./programs/eating-disorder-orange.svg": 38529,
	"./programs/eating-disorder-purple.svg": 29877,
	"./programs/eating-disorder-red.svg": 53316,
	"./programs/eating-disorder-soft.svg": 8215,
	"./programs/eating-disorder-white.svg": 78218,
	"./programs/entomophobia-orange.svg": 50139,
	"./programs/entomophobia-purple.svg": 60035,
	"./programs/entomophobia-red.svg": 75302,
	"./programs/entomophobia-soft.svg": 51925,
	"./programs/entomophobia-white.svg": 91732,
	"./programs/mild-depression,-orange.svg": 54349,
	"./programs/mild-depression-purple.svg": 57313,
	"./programs/mild-depression-red.svg": 6576,
	"./programs/mild-depression-soft.svg": 80147,
	"./programs/mild-depression-white.svg": 99342,
	"./programs/mild-depression.svg": 92802,
	"./programs/musophobia-orange.svg": 56481,
	"./programs/musophobia-purple.svg": 47733,
	"./programs/musophobia-red.svg": 20996,
	"./programs/musophobia-soft.svg": 93623,
	"./programs/musophobia-white.svg": 99914,
	"./programs/no-phobia.svg": 32810,
	"./programs/ornithophobia-orange.svg": 28886,
	"./programs/ornithophobia-purple.svg": 14262,
	"./programs/ornithophobia-red.svg": 17781,
	"./programs/ornithophobia-soft.svg": 83336,
	"./programs/ornithophobia-white.svg": 20151,
	"./programs/other-orange.svg": 94322,
	"./programs/other-purple.svg": 82026,
	"./programs/other-red.svg": 98617,
	"./programs/other-soft.svg": 65004,
	"./programs/other-white.svg": 20435,
	"./programs/panic-disorder-black.svg": 68911,
	"./programs/panic-disorder-orange.svg": 40068,
	"./programs/panic-disorder-purple.svg": 75808,
	"./programs/panic-disorder-red.svg": 46579,
	"./programs/panic-disorder-soft.svg": 39770,
	"./programs/panic-disorder-white.svg": 80837,
	"./programs/performance-orange.svg": 32394,
	"./programs/performance-purple.svg": 46674,
	"./programs/performance-red.svg": 55809,
	"./programs/performance-soft.svg": 48276,
	"./programs/performance-white.svg": 44411,
	"./programs/phobia-orange.svg": 5949,
	"./programs/phobia-purple.svg": 54905,
	"./programs/phobia-red.svg": 64136,
	"./programs/phobia-soft.svg": 43883,
	"./programs/phobia-white.svg": 76614,
	"./programs/public-speaking-orange.svg": 81318,
	"./programs/public-speaking-purple.svg": 87270,
	"./programs/public-speaking-red.svg": 94117,
	"./programs/public-speaking-soft.svg": 43672,
	"./programs/public-speaking-white.svg": 77767,
	"./programs/social-anxiety-orange.svg": 58216,
	"./programs/social-anxiety-purple.svg": 40780,
	"./programs/social-anxiety-red.svg": 31647,
	"./programs/social-anxiety-soft.svg": 33638,
	"./programs/social-anxiety-white.svg": 88121,
	"./programs/substance-abuse-orange.svg": 23117,
	"./programs/substance-abuse-purple.svg": 26793,
	"./programs/substance-abuse-red.svg": 30648,
	"./programs/substance-abuse-soft.svg": 53083,
	"./programs/substance-abuse-white.svg": 32054,
	"./programs/trypanophobia-orange.svg": 79186,
	"./programs/trypanophobia-purple.svg": 50538,
	"./programs/trypanophobia-red.svg": 56089,
	"./programs/trypanophobia-soft.svg": 7948,
	"./programs/trypanophobia-white.svg": 99827,
	"./programs/trypophobia-soft.svg": 72289,
	"./programs/vaping.svg": 54300,
	"./programs/vomiting-soft.svg": 78757,
	"./public-speaking.svg": 33743,
	"./question.svg": 64515,
	"./reduce.svg": 8465,
	"./references.svg": 55941,
	"./reports.svg": 13748,
	"./right-arrow.svg": 14263,
	"./search.svg": 64343,
	"./security.svg": 861,
	"./selection.svg": 8819,
	"./settings.svg": 20716,
	"./show.svg": 15784,
	"./sign out.svg": 22740,
	"./social-anxiety.svg": 23453,
	"./star.svg": 40815,
	"./subscription.svg": 36720,
	"./substance-abuse.svg": 50594,
	"./suggestion.svg": 55739,
	"./summary.svg": 79629,
	"./support.svg": 96212,
	"./team.svg": 49984,
	"./terms.svg": 84104,
	"./therapists.svg": 16974,
	"./time.svg": 97592,
	"./today.svg": 18118,
	"./toolbox.svg": 18276,
	"./trypanophobia.svg": 78619,
	"./trypophobia.svg": 64336,
	"./unlock.svg": 39099,
	"./up-arrow.svg": 3744,
	"./vaping-addiction.svg": 10540,
	"./view-vr.svg": 49429,
	"./viewed.svg": 42215,
	"./vomiting.svg": 27980,
	"./vr-headset-on-girl-2.svg": 82346,
	"./vr-headset-on-girl.svg": 2479,
	"./vr-headset.svg": 53606,
	"./vr.svg": 13535,
	"./warning-white.svg": 39749,
	"./warning.svg": 42865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;